'use strict';

/* jshint -W098 */
angular.module('mean.databases').controller('DatabasesEquipmentInvoicesController', ['$scope', 'Global', 'VendorService', 'MeanUser', 'userService', 'builderService', 'ngDialog', 'toaster', '$filter', 'ProjectEquipments', 'Trades', 'taskListService', 'contactService', 'Projects', 'tradeCodeService', 'Builders', 'ProjectTasks', 'aceUtils', 'NgTableParams', 'taskService',
  function($scope, Global, VendorService, MeanUser, userService, builderService, ngDialog, toaster, $filter, ProjectEquipments, Trades, taskListService, contactService, Projects, tradeCodeService, Builders, ProjectTasks, aceUtils, NgTableParams, taskService) {
    $scope.global = Global;
    $scope.package = {
      name: 'contacts'
    };

    $scope.user = MeanUser.user;
    $scope.importFileSelected = false;
    $scope.projectTasks = []
    $scope.vendorLists = []; 

    $scope.sortType = ['supplier', 'project_id.builder.name', 'project_id.name', 'phase', 'task_code'];
    $scope.sortReverse = false;

    $scope.$on('equipmentInvoicesLoadEvent', function (event, data) {
        if(data.materialDate) {
            ProjectEquipments.query({ 'trade': $scope.user.trade[0],
                'company_code': $scope.user.contractor_code,
                'supplier': data.searchProp.supplier,
                'project_id': data.searchProp.project_id,
                'task': data.searchProp.task,
                'no_date': true,
                'phase': data.searchProp.phase,
                'main_username': $scope.main_account.username,
                'populate': true }, function(equipments) {
                _.each(equipments, function(report) {
                    var convert = $filter('filter')(report.equipment, {
                        'name': 'User Added', 'description': 'Added in Database by Admin'}, true);

                    report.invoice_date = moment(report.invoice_date).format('MMM D, YYYY');

                    report.material_detail_total = 0;
                    _.each(report.equipment, function(mat) {
                        report.material_detail_total += mat.total;
                    });

                    //if the difference is less than a penny then don't worry about it
                    if(Math.abs(report.invoice_total - report.material_detail_total) < 0.02) {
                        report.material_detail_total = report.invoice_total;
                    }

                    if(convert.length > 0) {
                        _.each(convert, function(mat) {
                            mat.name = 'A.C.E. System Added Equipment';
                            mat.description = 'Equipment added by system to adjust total costs';
                        });

                        if(!report.userId) {
                            report['userId']= $scope.main_account._id
                        }

                        report.$update();
                    }
                });

                $scope.reports = equipments;

                var data = $scope.reports;

                $scope.tableListEquipmentParams = new NgTableParams({ count: 50 }, { dataset: data });
            });
        } else {
            ProjectEquipments.query({ 'trade': $scope.user.trade[0],
                'company_code': $scope.user.contractor_code,
                'supplier': data.searchProp.supplier,
                'project_id': data.searchProp.project_id,
                'date_type': data.searchProp.date_type,
                'start': data.searchProp.start,
                'end': data.searchProp.end,
                'task': data.searchProp.task,
                'phase': data.searchProp.phase,
                'main_username': $scope.main_account.username,
                'populate': true }, function(equipments) {
                _.each(equipments, function(report) {
                    var convert = $filter('filter')(report.equipment, {
                        'name': 'User Added', 'description': 'Added in Database by Admin'}, true);

                    report.invoice_date = moment(report.invoice_date).format('MMM D, YYYY');

                    report.material_detail_total = 0;
                    _.each(report.equipment, function(mat) {
                        report.material_detail_total += mat.total;
                    });

                    //if the difference is less than a penny then don't worry about it
                    if(Math.abs(report.invoice_total - report.material_detail_total) < 0.02) {
                        report.material_detail_total = report.invoice_total;
                    }

                    if(convert.length > 0) {
                        _.each(convert, function(mat) {
                            mat.name = 'A.C.E. System Added Equipment';
                            mat.description = 'Equipment added by system to adjust total costs';
                        });

                        if(!report.userId) {
                            report['userId']= $scope.main_account._id
                        }
                        report.$update();
                    }
                });

                $scope.reports = equipments;

                var data = $scope.reports;

                $scope.tableListEquipmentParams = new NgTableParams({ count: 50 }, { dataset: data });
            });
        }

        userService.getMainAccount($scope.user.username).then(function(main_account) {
            $scope.main_account = main_account;
            Trades.query({'main_account_id': $scope.main_account._id}, function(trade) {
                $scope.my_trade = trade[0];

                $scope.all_projects = $scope.$parent.all_projects;

                $scope.trade_tasks = angular.copy($scope.$parent.trade_tasks);
                _.remove($scope.trade_tasks, function(task) {
                    return task.task_code === 'All';
                });
            });
        });
    });

    var company = userService.getCompanyCode($scope.user.username);

    userService.getUsers($scope.user.trade[0], company).then(function(result) {
        $scope.users = result;
    });

    $scope.reloadTable = function() {
        var data = $scope.project_hours;
        $scope.tableListEquipmentParams.reload();
    };

    $scope.editActualTotal = function (item) {
        item.actualTotalEditing = true;
        item.originalActualTotal = item.actual_total;
    };

    $scope.viewMaterialDetails = function(item) {
            $scope.selectedReport = item;
            $scope.material_detail_total = 0;
            _.each(item.equipment, function(mat) {
                $scope.material_detail_total += mat.total;
            });
            $scope.material_details = item.equipment;

            if($scope.material_detail_total != item.invoice_total) {
                $scope.show_sync_button = true;
            } else {
                $scope.show_sync_button = false;
            }
        };

    $scope.doneActualTotalEditing = function (item) {
        if(!item.actualTotalEditing) return;

        //item.lots is an array of items that have the lot number
        //item.phase is the current phase we are working with
        var proj_lots = [];
        _.each(item.lots, function(lot) {
            var check = $filter('filter')(item.project_id.lots, {
                'number': lot.item, 'phase': item.phase }, true);
            if(check.length !== 1) {
                toaster.pop('error', 'Lot Processing Error', 'Contact Admin.');
                return;
            }

            proj_lots.push(check[0]);
        });
        
        var my_trade = $filter('filter')(item.project_id.trades, {
            'name': $scope.user.trade[0] }, true);

        if(my_trade.length !== 1) {
            toaster.pop('error', 'Cannot Get Trade', 'Contact Admin');
            return;
        }

        var proj_taxes = my_trade[0].company_factors.sales_tax;

        var adjusted_total = item.actual_total - item.originalActualTotal;
        var each_total = adjusted_total / item.lots.length;
        var each_subtot = each_total / (1 + proj_taxes);
        var each_tax = each_subtot * proj_taxes;
        
        _.each(proj_lots, function(lot) {
            //need to see if I already have system added equipment
            var equipment = $filter('filter')(item.equipment, {
                'lot': lot.number,
                'name': 'A.C.E. System Added Equipment',
                'description': 'Equipment added by system to adjust total costs' }, true);

            if(equipment.length === 0) {
                item.equipment.push({
                    bid_quantity: 0,
                    color_code: '',
                    delivery_price: 0,
                    foreman_note: '',
                    lot: lot.number,
                    name: 'A.C.E. System Added Equipment',
                    description: 'Equipment added by system to adjust total costs',
                    // name: 'User Added',
                    // description: 'Added in Database by Admin',
                    plan_code: lot.plan,
                    price_per_order: each_subtot,
                    quantity: 1,
                    sales_tax: each_tax,
                    sub_total: each_subtot,
                    total: each_total
                });
            } else if(equipment.length === 1) {
                equipment[0].price_per_order += each_subtot;
                equipment[0].sales_tax += each_tax;
                equipment[0].sub_total += each_subtot;
                equipment[0].total += each_total;
            } else {
                toaster.pop('error', 'Unexpected Error', 'Contact Admin');
                return;
            }
        });

        if(!item.userId) {
            item['userId']= $scope.main_account._id
        }

        item.$update(function(success) {
            toaster.pop('success', 'Actual Totals', 'Database updated');
        }, function(error) {
            toaster.pop('error', 'Actual Totals Error', error);
            item.actual_total = item.originalActualTotal;
        });

        item.actualTotalEditing = false;
    };

    $scope.getVendors = function(main_account_id) {
        VendorService.query({ type: 'All', vendorType: 'Equipment', isDeleted: false, userId: main_account_id}, function(results) {
            $scope.vendorLists = results;
        });
    }

    $scope.editSupplierNumber = function(item) {
        item.supplierNumberEditing = true;
    };

    $scope.doneSupplierNumberEditing = function(item) {
        if(!item.supplierNumberEditing) return;
        $scope.updateSupplierNumber(item);
        item.supplierNumberEditing = false;
    };

    $scope.updateSupplierNumber = function(item) {
        if(!item.userId) {
            item['userId']= $scope.main_account._id
        }
        item.$update(function(success) {
            toaster.pop('success', 'Supplier Number Updated');
        }, function(error) {
            toaster.pop('error', 'Supplier Number Update Error', error);
        });
    };

    $scope.editInvoiceTotal = function(item) {
        item.invoiceTotalEditing = true;
        item.originalInvoiceTotal = item.invoice_total;
    };

    $scope.doneInvoiceTotalEditing = function (item) {
            if (!item.invoiceTotalEditing) return;

            if(item.invoice_total < 0) {
                toaster.pop('error', 'Negative Total Value', 
                    'The system does not handle negative invoice totals at this time.');
                item.invoice_total = item.originalInvoiceTotal;
                item.invoiceTotalEditing = false;
                return;
            }

            //item.lots is an array of items that have the lot number
            //item.phase is the current phase we are working with
            var proj_lots = [];
            _.each(item.lots, function (lot) {
                var check = $filter('filter')(item.project_id.lots, {
                    'number': lot.item, 'phase': item.phase
                }, true);
                if (check.length !== 1) {
                    toaster.pop('error', 'Lot Processing Error', 'Contact Admin.');
                    return;
                }

                proj_lots.push(check[0]);
            });

            var my_trade = $filter('filter')(item.project_id.trades, {
                'name': $scope.user.trade[0]
            }, true);

            if (my_trade.length !== 1) {
                toaster.pop('error', 'Cannot Get Trade', 'Contact Admin');
                return;
            }

            var proj_taxes = my_trade[0].company_factors.sales_tax;

            var adjusted_total = item.invoice_total - item.originalInvoiceTotal;
            var each_total = adjusted_total / item.lots.length;
            var each_subtot = each_total / (1 + proj_taxes);
            var each_tax = each_subtot * proj_taxes;

            _.each(proj_lots, function (lot) {
                //need to see if I already have system added material
                var equipment = $filter('filter')(item.equipment, {
                    'lot': lot.number,
                    'name': 'A.C.E. System Added Equipment',
                    'description': 'Equipment added by system to adjust Invoice Total costs'
                }, true);

                if (equipment.length === 0) {
                    item.equipment.push({
                        bid_quantity: 0,
                        color_code: '',
                        delivery_price: 0,
                        foreman_note: '',
                        lot: lot.number,
                        name: 'A.C.E. System Added Equipment',
                        description: 'Equipment added by system to adjust Invoice Total costs',
                        plan_code: lot.plan,
                        price_per_order: each_subtot,
                        quantity: 1,
                        sales_tax: each_tax,
                        sub_total: each_subtot,
                        total: each_total
                    });
                } else if (equipment.length === 1) {
                    equipment[0].price_per_order += each_subtot;
                    equipment[0].sales_tax += each_tax;
                    equipment[0].sub_total += each_subtot;
                    equipment[0].total += each_total;
                } else {
                    toaster.pop('error', 'Unexpected Error', 'Contact Admin');
                    return;
                }
            });

            if(!item.userId) {
                item.userId = $scope.main_account._id;
            }

            if(!item.userId) {
                item.userId = $scope.main_account._id;
            }
            if (!item.invoice_date) {
                item.invoice_date = moment(angular.copy(item.delivery_date));
            } else {
                item.invoice_date = moment(item.invoice_date)
            }

            if (!item.invoice_total) {
                item.invoice_total = angular.copy(item.actual_total);
            }

            if (!item.originalInvoiceTotal) {
                item.originalInvoiceTotal = angular.copy(item.actual_total);
            }

            item.$update(function (success) {
                item.invoice_total = success.invoice_total;
                item.invoice_date = moment(success.invoice_date);
                success.material_detail_total = 0;
                _.each(success.equipment, function(mat) {
                    success.material_detail_total += mat.total;
                });

                //if the difference is less than a penny then don't worry about it
                if(Math.abs(success.invoice_total - success.material_detail_total) < 0.02) {
                    success.material_detail_total = success.invoice_total;
                }
                toaster.pop('success', 'Invoice Total', 'Database updated');
            }, function (error) {
                toaster.pop('error', 'Invoice Total', 'There was a problem updating the database');
                item.invoice_total = item.originalInvoiceTotal;
            });

            item.invoiceTotalEditing = false;
        };

    $scope.editInvoiceDate = function (item) {
        item.invoiceDateEditing = true;
        item.originalInvoiceDate = item.invoice_date;
    };

    $scope.doneInvoiceDateEditing = function (item) {
        if(!item.invoiceDateEditing) return;
        if(!item.userId) {
            item['userId']= $scope.main_account._id
        }
        item.invoice_date = new Date(item.invoice_date);
        item.$update(function(success) {
            item.invoice_date = moment(success.invoice_date);//.format('MMM D, YYYY');
            toaster.pop('success', 'Invoice Date', 
                'Database updated');
        }, function(error) {
            toaster.pop('error', 'Invoice Date', 
                'There was a problem updating the database');
            item.invoice_date = item.originalInvoiceDate;
        });

        item.invoiceDateEditing = false;
    };

    $scope.newEquipmentInvoiceOperation = function () {
        //if the tasks have not been defined, do it now
        if(!$scope.extra_tasks) {
            $scope.getBuilderList();
            taskListService.getByTrade(tradeCodeService.getCode(
                    $scope.user.trade[0])).then(function(result) {
                $scope.extra_tasks = $filter('orderBy')(result, 'task_code');
            });
        }

        // Get Vendors lists
        $scope.getVendors($scope.main_account._id);
        
        $scope.new_extra = true;

        $scope.returnedOptions = {
            builder: '',
            project_id: '',
            supplier: '',
            supplier_number: 'TBD',
            plan: '',
            phase: '',
            task: '',
            lot: '',
            total: 0,
            bid_total: 'NA',
            actual_total: 'NA',
            po_number: 'NA',
            invoiceNumber: 'NA',
            delivery_date: moment().subtract(1, "days"),
            report_date: moment().subtract(1, "days"),
            invoice_date: moment().subtract(1, "days"),
            invoice_total: 0,
            note: '',
        };

        ngDialog.openConfirm({
            template: 'databases/views/tmpl/databases-edit-equipment-invoices.html',
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            if(!$scope.returnedOptions.lot) {
                toaster.pop('error', 'Lot Selection', 'You must select a lot.');
                return;
            }

            if($scope.returnedOptions.extra_task === '') {
                toaster.pop('error', 'Task Selection', 'You must select a task.');
                return;
            }
            var multi_phase = $filter('unique')($scope.returnedOptions.lot, 'phase');
            if(multi_phase.length !== 1) {
                toaster.pop('error', 'Task Selection', 'You must select lots from a single phase.');
                return;
            }

            var my_trade = $filter('filter')($scope.returnedOptions.project_id.trades, {
                'name': $scope.user.trade[0] }, true);

            if(my_trade.length !== 1) {
                toaster.pop('error', 'Cannot Get Trade', 'Contact Admin');
                return;
            }

            var proj_taxes = my_trade[0].company_factors.sales_tax;

            var each_total = $scope.returnedOptions.invoice_total / $scope.returnedOptions.lot.length;
            var each_subtot = each_total / (1 + proj_taxes);
            var each_tax = each_subtot * proj_taxes;

            ProjectEquipments.query({
                'project_id': $scope.returnedOptions.project_id._id,
                'phase': $scope.returnedOptions.lot[0].phase,
                'task_code': $scope.returnedOptions.task.task_code }, function(projMatsDB) {
            
                ProjectTasks.query({'project_id': $scope.returnedOptions.project_id._id,
                    'phase': $scope.returnedOptions.lot[0].phase,
                    'lot': $scope.returnedOptions.lot[0].number,
                    'task_code': $scope.returnedOptions.task.task_code }, function(tasks) {
                    if(tasks.length !== 1) {
                        toaster.pop('error', 'Project Task Error', 
                            'Cannot find a project task associated with the selection.  Please verify selected lot/task has been scheduled.');
                        return;
                    }

                    var my_lots = [];
                    var my_equipment = [];
                    //console.log('adding lot equipments ' + $scope.returnedOptions.lot);
                    _.each($scope.returnedOptions.lot, function(lot) {
                        my_lots.push({
                            item: lot.number
                        });

                        my_equipment.push({
                            bid_quantity: 0,
                            color_code: '',
                            delivery_price: 0,
                            foreman_note: '',
                            lot: lot.number,
                            name: 'A.C.E. System Added Equipment',
                            description: 'Equipment added by system to adjust total costs',
                            plan_code: lot.plan,
                            price_per_order: each_subtot,
                            quantity: 1,
                            sales_tax: each_tax,
                            sub_total: each_subtot,
                            total: each_total
                        });
                    });

                    var equipment_report = new ProjectEquipments({
                        actual_total: $scope.returnedOptions.invoice_total,
                        bid_total: 0,
                        company_code: $scope.returnedOptions.project_id.company_code,
                        date_reviewed: new Date($scope.returnedOptions.invoice_date),
                        date_submitted: new Date($scope.returnedOptions.invoice_date),
                        delivery_date: new Date($scope.returnedOptions.invoice_date),
                        invoice_date: new Date($scope.returnedOptions.invoice_date),
                        invoice_total: $scope.returnedOptions.invoice_date.invoice_total,
                        job_code: $scope.returnedOptions.project_id.job_code,
                        lots: my_lots,
                        main_report: true,
                        equipment: my_equipment,
                        quantities_corrected: true,
                        reviewed: true,
                        submitted: true,
                        invoiceNumber: $scope.returnedOptions.invoiceNumber,
                        manually_entered: true,
                        merged: false,
                        phase: $scope.returnedOptions.lot[0].phase,
                        project_id: $scope.returnedOptions.project_id._id,
                        project_task_id: tasks[0]._id,
                        report_date: new Date($scope.returnedOptions.invoice_date),
                        start_date: new Date($scope.returnedOptions.invoice_date),
                        sub_report_number: projMatsDB.length,
                        supplier: $scope.returnedOptions.supplier.name,
                        supplier_number: $scope.returnedOptions.supplier_number,
                        task_code: $scope.returnedOptions.task.task_code,
                        task_name: tasks[0].task_name,
                        foreman_id: tasks[0].trade_manager_id,
                        trade: $scope.user.trade[0],
                        userId: $scope.main_account._id
                    });

                    equipment_report.$save(function(success) {
                        toaster.pop('success', 'Equipment Invoice', 'Database updated');
                    }, function(error) {
                        toaster.pop('error', 'Equipment Invoice', error);
                    });
                });
            });
        }, function (value) {
            //Do something
            console.log('in the do something section');
        });
    };

    $scope.changeBuilder = function(builder) {
        if(!builder) return;
        $scope.projects = [];
        $scope.tasks = [];
        $scope.phases = [];
        $scope.lots = [];
        $scope.bid_tasks = [];
        $scope.trades = [];

        $scope.projects = $filter('filter')($scope.all_projects, {
            'company_code': builder.company_code, 
            'trade_code': builder.trade_code }, true);

        $filter('orderBy')($scope.projects, 'name');
    };

    $scope.doneProjectNameEditing = function (item) {
        $scope.lots = $filter('orderBy')(item.lots, ['phase', 'number']);
        //$scope.lots = $filter('filter')(item.lots, {'scheduled': true}, true);
        $scope.projectTasks = $filter('filter')($scope.trade_tasks, { 
            geoLocation: item['geoLocation'], projectType: item['projectType']}, true);
    };

    $scope.getBuilderList  = function() {
        userService.getMainAccount($scope.user.username).then(function(main_account) {
            $scope.main_account = main_account;
            contactService.getMyContacts($scope.main_account._id).then(function(contacts) {
                $scope.builders = [];

                Trades.query({'main_account_id': $scope.main_account._id}, function(trade) {
                    trade[0].trade_code = trade[0].trade_code?trade[0].trade_code:
                                                        tradeCodeService.getCode(trade[0].trade)
                    $scope.my_trade = trade[0];
                    $scope.builders.push(trade[0]);

                    contacts.builders.forEach(function(builder) {
                        Builders.query({'builder': builder._id}, function(builders) {
                            _.each(builders, function(builder) {
                                builder.company_code = aceUtils.padDigits(builder.company_code, 3);
                                builder.trade_code = builder.trade_code?builder.trade_code:
                                                            tradeCodeService.getCode(builder.trade)
                                $scope.builders.push(builder);
                            });
                        });
                    });
                });
            });
        });
    };

    $scope.editInvoiceOperation = function (item) {
        $scope.lots = $filter('orderBy')(item.project_id.lots, ['phase', 'number']);
        //$scope.lots = item.project_id.lots;
        $scope.new_extra = false;

        var selected_lots = [];

        $scope.selectedReport = item;

        _.each(item.lots, function(lot) {
            _.each($scope.lots, function(main) {
                if(lot.item === main.number) {
                    selected_lots.push(main);
                }
            });
        });

        var task = $filter('filter')($scope.trade_tasks, { 'task_code': item.task_code }, true)[0];

        $scope.returnedOptions = {
            builder: item.project_id.builder,
            project_id: item.project_id,
            supplier: item.supplier.name,
            supplier_number: item.supplier_number,
            phase: item.phase,
            task: task,
            task_code: item.task_code,
            sub_report_number: item.sub_report_number,
            bid_total: item.bid_total,
            actual_total: item.actual_total,
            lot: selected_lots,
            total: item.actual_total,
            invoice_total: item.invoice_total,
            invoice_date: item.invoice_date,
            report_date: item.report_date ? new moment(item.report_date) : '',
            delivery_date: item.delivery_date ? new moment(item.delivery_date) : '',
            note: item.note,
        };

        ngDialog.openConfirm({
            template: 'databases/views/tmpl/databases-edit-equipment-invoices.html',
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            var original_mat_total = 0;
            _.each($scope.selectedReport.equipment, function(mat) {
                original_mat_total += mat.total;
            });

            var my_trade = $filter('filter')($scope.returnedOptions.project_id.trades, {
                'name': $scope.user.trade[0] }, true);

            if(my_trade.length !== 1) {
                toaster.pop('error', 'Cannot Get Trade', 'Contact Admin');
                return;
            }

            var proj_taxes = my_trade[0].company_factors.sales_tax;

            //$scope.returnedOptions.total is the report total but we need
            //to add equipment to compensate.
            var adjusted_total = $scope.returnedOptions.total - original_mat_total;
            var my_lots = [];
            var each_total = adjusted_total / $scope.returnedOptions.lot.length;
            var each_subtot = each_total / (1 + proj_taxes);
            var each_tax = each_subtot * proj_taxes;
            
            _.each($scope.returnedOptions.lot, function(lot) {
                my_lots.push({
                    item: lot.number
                });

                //need to see if I already have system added material
                var equipment = $filter('filter')($scope.selectedReport.equipment, {
                    'lot': lot.number,
                    'plan_code': lot.plan,
                    'name': 'A.C.E. System Added Equipment',
                    'description': 'Equipment added by system to adjust total costs' }, true);

                if(equipment.length === 0) {
                    $scope.selectedReport.equipment.push({
                        bid_quantity: 0,
                        color_code: '',
                        delivery_price: 0,
                        foreman_note: '',
                        lot: lot.number,
                        name: 'A.C.E. System Added Equipment',
                        description: 'Equipment added by system to adjust total costs',
                        // name: 'User Added',
                        // description: 'Added in Database by Admin',
                        plan_code: lot.plan,
                        price_per_order: each_subtot,
                        quantity: 1,
                        sales_tax: each_tax,
                        sub_total: each_subtot,
                        total: each_total
                    });
                } else if(equipment.length === 1) {
                    equipment[0].price_per_order += each_subtot;
                    equipment[0].sales_tax += each_tax;
                    equipment[0].sub_total += each_subtot;
                    equipment[0].total += each_total;
                } else {
                    toaster.pop('error', 'Unexpected Error', 'Contact Admin');
                    return;
                }
            });

            $scope.selectedReport.lots = my_lots;
            $scope.selectedReport.actual_total = $scope.returnedOptions.total;
            $scope.selectedReport.supplier = $scope.returnedOptions.supplier.name;
            $scope.selectedReport.supplier_number = $scope.returnedOptions.supplier_number;
            $scope.selectedReport.report_date = new Date($scope.returnedOptions.report_date);
            $scope.selectedReport.delivery_date = new Date($scope.returnedOptions.delivery_date);
            $scope.selectedReport.invoice_date = new Date($scope.returnedOptions.invoice_date);
            $scope.selectedReport.invoice_total = $scope.returnedOptions.invoice_total;

            if($scope.selectedReport.task_code !== 
                $scope.returnedOptions.task.task_code) {
                ProjectTasks.query({'project_id': $scope.returnedOptions.project_id._id,
                    'phase': $scope.returnedOptions.lot[0].phase,
                    'lot': $scope.returnedOptions.lot[0].number,
                    'task_code': $scope.returnedOptions.task.task_code }, function(project_tasks) {

                    if(project_tasks.length !== 1) {
                        toaster.pop('error', 'Project Task Error', 
                            'Did not get the expected number of project tasks. Contact Admin.');
                        return;
                    }

                    $scope.selectedReport.project_task_id = project_tasks[0]._id;
                    $scope.selectedReport.task_code = project_tasks[0].task_code;
                    $scope.selectedReport.task_name = project_tasks[0].task_name;

                    if(!$scope.selectedReport.userId) {
                        $scope.selectedReport.userId = $scope.main_account._id;
                    }
                    $scope.selectedReport.$update(function(success) {
                        var idx = $scope.reports.indexOf(success);
                        $scope.reports[idx] = success;
                        toaster.pop('success', 'Equipment Invoice', 'Database updated');
                    }, function(error) {
                        toaster.pop('error', 'Equipment Invoice Error', error);
                    });
                });
            } else {
                if(!$scope.selectedReport.userId) {
                    $scope.selectedReport.userId = $scope.main_account._id;
                }
                $scope.selectedReport.$update(function(success) {
                    var idx = $scope.reports.indexOf(success);
                    $scope.reports[idx] = success;
                    toaster.pop('success', 'Equipment Invoice', 'Database updated');
                }, function(error) {
                    toaster.pop('error', 'Equipment Invoice Error', error);
                });
            }
        }, function (value) {
            //Do something
            console.log('in the do something section');
        });
    };

    $scope.incorrectPricingChange = function(item) {
        if(!item.userId) {
            item['userId']= $scope.main_account._id
        }
        item.$update(function(success) {
            var idx = $scope.reports.indexOf(success);
            $scope.reports[idx] = success;
            toaster.pop('success', 'Equipment Invoice', 'Database updated');
        }, function(error) {
            toaster.pop('error', 'Equipment Invoice Error', error);
        });
    };

    $scope.removeInvoice = function(item) {
        item.$delete(function(success) {
            toaster.pop('success', 'Equipment Invoice', 'Removed from database');
            var idx = $scope.reports.indexOf(item);
            if(idx === -1) {
                toaster.pop('warning', 'Invoice Not Found', 
                    'Could not determine proper invoice from list.  Please resubmit query to refresh the list.');
            } else {
                $scope.reports.splice(idx, 1);
                $scope.reloadTable();
            }
        }, function(error) {
            toaster.pop('error', 'Equipment Invoice', error);
        });
    };

    $scope.removeInvoiceOperation = function(item) {
        ngDialog.openConfirm({
            template:
                '<h2>Delete Equipment Invoice Data</h2>' +
                '<p>This operation will delete equipment data from the system</p>' +
                '<p>Are you sure you want to continue? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            // perform delete operation
            $scope.removeInvoice(item);
        }, function (value) {
            //Do something 
            console.log('in the do something section of removeInvoiceOperation');
        });
    };

    $scope.ConvertToCSV = function(objArray) {
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        var str = 'Supplier,Builder,Project Name,Phase,Lot,Task,PO Number,Date Ordered,Date Delivered,Projected Total,PO Total,Invoice Number,Invoice Date,Invoice Total,Incorrect Pricing';
        str += '\r\n';

        for(var i=0; i<array.length; i++) {
            var builder_name = (array[i].project_id)?array[i].project_id.builder.name: '';
            var name = (array[i].project_id)?array[i].project_id.name: '';
            var invoice_number = '';
            if (array[i].project_id) {
                invoice_number = array[i].project_id.trade_code + '-' +
                    array[i].project_id.company_code + '-' +
                    array[i].project_id.job_code + '-' +
                    array[i].phase + '-' +
                    array[i].task_code + '-' +
                    array[i].sub_report_number;
            }
            var pricing = '';
            if(array[i].incorrect_pricing) {
                pricing = 'True';
            }
            var sup_number = '';
            if(array[i].supplier_number) {
                sup_number = array[i].supplier_number;
            }
            var lot = '';
            if(array[i].lots.length > 1) {
                lot = 'MLT';
            } else if(array[i].lots.length == 1) {
                lot = array[i].lots[0].item;
            }

            str += array[i].supplier + ',' +
                    builder_name + ',' +
                    name + ',' +
                    array[i].phase + ',' +
                    lot + ',' +
                    array[i].task_code + ',' +
                    invoice_number + ',' +
                    moment(array[i].date_submitted).format('MM/DD/YYYY') + ',' +
                    moment(array[i].delivery_date).format('MM/DD/YYYY') + ',' +
                    array[i].bid_total + ',' +
                    array[i].actual_total + ',' +
                    sup_number + ',' +
                    moment(array[i].invoice_date).format('MM/DD/YYYY') + ',' +
                    array[i].invoice_total + ',' +
                    pricing;
            str += '\r\n';
        }

        return str;
    };

    $scope.exportEquipmentData = function() {
        var sorted = $filter('orderBy')($scope.reports, ['supplier', 'project_id.builder.name', 'project_id.name', 'phase', 'task_code']);
        var dataUrl = 'data:text/csv;utf-8,' + 
            encodeURI($scope.ConvertToCSV(sorted));
        var link = document.createElement('a');
      
        angular.element(link)
            .attr('href', dataUrl)
            .attr('download', 'equipment_invoices.csv'); // Pretty much only works in chrome
      
        link.click();
    };

    $scope.fileSelected = function() {
        $scope.importFileSelected = true;
    };

    $scope.materialFileSelected = function() {
        var fileContent = this.fileContent;
        var errors = false;

        ProjectEquipments.query({
            'trade': $scope.user.trade[0], 
            'company_code': $scope.user.contractor_code,
            'submitted': true }, function(projMatsDB) {

            var lines, lineNumber, data, length;
            
            lines = fileContent.split('\n');
            lines.shift(); //remove the heading
            lines.pop(); //remove the last entry that is an empty string

            var users = [];
            var projects = [];

            var data = [];
            _.each(lines, function(line, idx) {
                data = line.split(',');
                _.each(data, function(item) {
                    item = item.trim();
                });

                var phaseCheck = data[3].match(/[a-z]/i);
                if(phaseCheck) {
                    //this phase has a character modifier
                    if(data[3].length === 2) {
                        data[3] = '0' + data[3];
                    } 
                } else {
                    data[3] = aceUtils.padDigits(data[3], 2);
                }

                data[5] = aceUtils.padDigits(data[5], 4);

                if(data.length !== 15) {
                    var lineNum = idx + 2;
                    var error_str = 'Problem with line ' + lineNum + '.<br/>' +
                        'Data items should be 10 but this line has ' + data.length +
                        '.  Make sure there are no commas in the csv file.';
                    toaster.pop({
                        type: 'error', 
                        title: 'Line Error', 
                        body: error_str,
                        timeout: 0,
                        bodyOutputType: 'trustedHtml',
                        showCloseButton: true
                    });
                    errors = true;
                } else {
                    var validDate = moment(data[12], 'M/D/YYYY',true).isValid();
                    if(validDate) {
                        var invoiceNumberArray = data[6].split('-');
                        var haveProject = $filter('filter')($scope.all_projects, {
                            'trade_code': invoiceNumberArray[0], 
                            'company_code': invoiceNumberArray[1], 
                            'job_code': invoiceNumberArray[2]
                        }, true);

                        if(haveProject.length === 1) {
                            var inlist = $filter('filter')(projects, {
                                '_id': haveProject[0]._id }, true);

                            //We'll only get the latest revisions but we don't want
                            //to get all the plans so let's pair that down here
                            if(!haveProject[0].get_tasks) haveProject[0].get_tasks = [];

                            var lots = [];
                            if(data[4] == 'MLT') {
                                //set lots to all the lots in the phase
                                lots = $filter('filter')(haveProject[0].lots, {'phase': data[3]}, true);
                            } else {
                                var lot_strings = data[4].split('-');
                                _.each(lot_strings, function(lot) {
                                    lot = aceUtils.padDigits(lot, 3);
                                    lots.push($filter('filter')(haveProject[0].lots, {
                                        'phase': data[3], 'number': lot }, true)[0]);
                                });
                            }

                            _.each(lots, function(lot) {
                                var bidInList = $filter('filter')(haveProject[0].get_tasks, {
                                    'phase': data[3],
                                    'number': lot.number }, true);

                                if(bidInList.length === 0) {
                                    var planCode = $filter('filter')(haveProject[0].lots, {
                                        'phase': data[3], 'number': lot.number}, true);

                                    if(planCode.length !== 1) {
                                        var lineNum = idx + 2;
                                        error_str = 'Problem with line ' + lineNum + '.  ';
                                        if(planCode.length === 0) {
                                            error_str += 'No lot found for (phase/lot) ' + 
                                                data[3] + '/' + lot.number + '.';
                                        } else {
                                            error_str += 'Found ' + planCode.length + ' matching lots for (phase/lot) ' + 
                                                data[3] + '/' + lot.number + '.';
                                        }
                                        toaster.pop({
                                            type: 'error', 
                                            title: 'Project Lot Error', 
                                            body: error_str,
                                            timeout: 0,
                                            bodyOutputType: 'trustedHtml',
                                            showCloseButton: true
                                        });
                                        errors = true;
                                    } else {
                                        var planInList = $filter('filter')(haveProject[0].get_tasks, {
                                            'phase': data[3], 'number': lot.number }, true);

                                        if(planInList.length === 0) {
                                            haveProject[0].get_tasks.push({
                                                'phase': data[3],
                                                'number': lot.number,
                                                'trade': $scope.user.trade[0],
                                                'plan': planCode[0].plan
                                            });
                                        }
                                    }
                                }
                            });

                            if(inlist.length === 0) {
                                projects.push(haveProject[0]);
                            } 
                        } else {
                            var lineNum = idx + 2;
                            var error_str = 'Problem with project info on line ' + lineNum + '.<br/>' +
                                'Problem getting project for (trade/company_code/job): ' +
                                data[0] + '/' + data[1] + '/' + data[2] + 
                                '.<br/>Make sure project exists.';
                            toaster.pop({
                                type: 'error', 
                                title: 'Project Error', 
                                body: error_str,
                                timeout: 0,
                                bodyOutputType: 'trustedHtml',
                                showCloseButton: true
                            });
                            errors = true;
                        }
                    } else {
                        var lineNum = idx + 2;

                        var error_str = 'Problem with project info on line ' + lineNum + '.<br/>' +
                            'Problem with date: ' + data[8] + '.  ' + 'Not a valid date string (m/d/yyyy).';
                        toaster.pop({
                            type: 'error', 
                            title: 'Date Error', 
                            body: error_str,
                            timeout: 0,
                            bodyOutputType: 'trustedHtml',
                            showCloseButton: true
                        });
                        errors = true;
                    }
                }
            });

            if (!errors) {
                taskService.getProjectTasksForLot(projects).then(function (results) {
                    var total_entries = lines.length;
                    var count = 0;
                    var allErrors = [];
                    var error_str = '';

                    _.each(lines, function (line, idx) {
                        data = line.split(',');
                        _.each(data, function (item) {
                            item = item.trim();
                        });

                        var phaseCheck = data[3].match(/[a-z]/i);
                        if (phaseCheck) {
                            //this phase has a character modifier
                            if (data[3].length === 2) {
                                data[3] = '0' + data[3];
                            }
                        } else {
                            data[3] = aceUtils.padDigits(data[3], 2);
                        }

                        if(data[4] != 'MLT')
                            data[4] = aceUtils.padDigits(data[4], 3);
                        data[5] = aceUtils.padDigits(data[5], 4);

                        var invoiceNumberArray = data[6].split('-');

                        var currProj = $filter('filter')(projects, {
                            'trade_code': invoiceNumberArray[0], 
                            'company_code': invoiceNumberArray[1], 
                            'job_code': invoiceNumberArray[2]
                        }, true);

                        var lots = [];
                        if(data[4] == 'MLT') {
                            //set lots to all the lots in the phase
                            lots = $filter('filter')(currProj[0].lots, {'phase': data[3]}, true);
                        } else {
                            lots = data[4].split('-');
                            var temp_lots = [];
                            _.each(lots, function(lot) {
                                temp_lots.push($filter('filter')(currProj[0].lots, {
                                    'phase': data[3], 'number': aceUtils.padDigits(lot, 3)}, true)[0])
                            });
                            lots = temp_lots;
                        }

                        var save_error = false;
                        var project_good = true;
                        var task_good = true;
                        var foreman_good = false;
                        var newDate = new Date(data[12]);
                        newDate.setHours(8);

                        if (currProj.length !== 1) {
                            if (currProj.length === 0) {
                                error_str += 'Problem finding project for (trade/company/job): ' +
                                    data[0] + '/' + data[1] + '/' + data[2];
                            } else {
                                error_str += 'Found too many projects for (trade/company/job): ' +
                                    data[0] + '/' + data[1] + '/' + data[2];
                            }
                            console.log(error_str);
                            project_good = false;
                            save_error = true;
                        }

                        var my_trade = $filter('filter')(currProj[0].trades, {
                            'name': $scope.user.trade[0]
                        }, true);

                        if (my_trade.length !== 1) {
                            if (my_trade.length === 0) {
                                error_str += 'Trade not found.';
                            } else {
                                error_str += 'Too many trades returned';
                            }
                            save_error = true;
                        } else {
                            var currTasks = $filter('filter')(results, {
                                'project_id': currProj[0]._id,
                                'phase': data[3], 'task_code': data[5]
                            });

                            if (currTasks.length == 0) {
                                error_str += 'Problem finding task for Project ' + currProj[0].name +
                                    '.  There are no tasks associated with (phase/task): ' +
                                    data[3] + '/' + data[5] + ' requested in the data file.';
                                console.log(error_str);
                                task_good = false;
                                save_error = true;
                            } else {
                                var foreman = $filter('filter')($scope.users, { 'username': currTasks[0].foreman.username }, true);

                                if (foreman.length !== 1) {
                                    if (foreman.length === 0) {
                                        error_str += 'Problem finding user information for foreman ' +
                                            currTasks[0].foreman.username + ' for (Project/Task/Plan): ' +
                                            currProj[0].name + '/' + currTasks[0].task_code + '/' + currTasks[0].plan_code;
                                    } else {
                                        error_str += 'Found too many foreman ' +
                                            currTasks[0].foreman.username + ' for (Project/Task/Plan): ' +
                                            currProj[0].name + '/' + currTasks[0].task_code + '/' + currTasks[0].plan_code;
                                    }
                                    console.log(error_str);
                                    save_error = true;
                                } else {
                                    foreman_good = true;
                                }

                                var dummy_material = [];
                                var proj_taxes = my_trade[0].company_factors.sales_tax;
                                var each_total = data[13] / lots.length;
                                var each_subtot = each_total / (1 + proj_taxes);
                                var each_tax = each_subtot * proj_taxes;

                                _.each(lots, function(lot) {
                                    var currTask = $filter('filter')(currTasks, {'lot': lot.number}, true);

                                    if(currTask.length == 1) {
                                        dummy_material.push({
                                            bid_quantity: 0,
                                            color_code: '',
                                            delivery_price: 0,
                                            foreman_note: '',
                                            lot: lot.number,
                                            name: 'A.C.E. System Added Equipment',
                                            description: 'Equipment added by system to adjust total costs',
                                            plan_code: currTask[0].plan_code,
                                            price_per_order: each_subtot,
                                            quantity: 1,
                                            sales_tax: each_tax,
                                            sub_total: each_subtot,
                                            total: each_total
                                        });
                                    } else {
                                        task_good = false;
                                    }
                                });

                                var db_entry = $filter('filter')(projMatsDB, {
                                    'project_id': currProj[0]._id,
                                    'phase': data[3],
                                    'task_code': data[5]
                                }, true);

                                if (db_entry.length && data[5] !== db_entry[0].task_code) {
                                    console.log('The task codes do not match');
                                }

                                var inv_lots = [];
                                _.each(lots, function(lot) {
                                    inv_lots.push({
                                        'item': lot.number
                                    })
                                });

                                //now we have the projectBids associated with the projectHours we have to build
                                var material_report = new ProjectEquipments({
                                    actual_total: parseFloat(data[9]),
                                    bid_total: 0,
                                    company_code: invoiceNumberArray[1],
                                    date_reviewed: newDate,
                                    date_submitted: newDate,
                                    delivery_date: new Date(data[8]),
                                    invoice_date: newDate,
                                    invoice_total: parseFloat(data[13]),
                                    job_code: invoiceNumberArray[2],
                                    lots: inv_lots,
                                    main_report: true,
                                    equipment: dummy_material,
                                    quantities_corrected: true,
                                    reviewed: true,
                                    submitted: true,
                                    manually_entered: true,
                                    merged: false,
                                    phase: data[3],
                                    report_date: new Date(data[7]),
                                    start_date: newDate,
                                    sub_report_number: db_entry.length,
                                    supplier: data[0],
                                    supplier_number: (data[11]) ? data[11] : 'TBD',
                                    task_code: invoiceNumberArray[4],
                                    task_name: currTasks[0].task_name,
                                    trade: currTasks[0].trade,
                                    userId: $scope.main_account._id
                                });

                                if (project_good) {
                                    material_report.project_id = currProj[0]._id;
                                }

                                if (task_good) {
                                    material_report.project_task_id = currTasks[0]._id;
                                }

                                if (foreman_good) {
                                    material_report.foreman_id = foreman[0]._id;
                                }

                                projMatsDB.push(material_report);
                                if (!$scope.new_reports) $scope.new_reports = [];

                                count++;
                                $scope.new_reports.push(material_report);
                            }
                        }

                        if (save_error) {
                            allErrors.push(error_str);
                        }
                    });

                    if (count === total_entries) {
                        ProjectEquipments.bulkAdd($scope.new_reports, function (res) {
                            toaster.pop('success', 'Equipment Invoices Updated');
                        }, function (error) {
                            toaster.pop('error', 'Equipment Invoices Error', error);
                        });
                    }

                    if (allErrors.length > 0) {
                        toaster.pop({
                            type: 'error',
                            title: 'Error Saving Data',
                            body: 'There were errors with one or more lines from the csv file.' +
                                '  Invoices were saved but you will have to update individual items.',
                            timeout: 0,
                            showCloseButton: true
                        });
                    }
                    $scope.importFileSelected = false;
                });
            }
        });
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/databases/public/controllers/databases-equipment-invoices.js